import type { SetCopy } from '../catalog'

export const GREAT_MINDS: SetCopy[] = [
  {
    slug: 'da-vinci-workshop',
    series: 'great-minds',
    number: 1,
    name: "Leonardo's Workshop",
    maker: 'Leonardo da Vinci',
    year: 1503,
    tagline: 'A flying machine four centuries early.',
    story:
      'Leonardo filled his notebooks with wings, gears and anatomy, and designed the ornithopter long before anyone could fly. In his Florence workshop, c. 1503-1506, it rides high on its test stand, pitched nose-up with canvas bat wings spread on reddish-brown ribs and his apprentice Salai lying in the hull. Below, the Mona Lisa stands on his easel, the Vitruvian Man is pinned to the wall, and his bench, a cupboard of pigments and a drawing table with his armoured car fill the room.',
    age: '18+',
    palette: {
      cover: '#D9C49C',
      flood: '#A9794A',
      ink: '#2A1C10',
      ground: '#E8DCC4',
      accent: '#C9A227',
    },
    aliases: [
      'leonardo',
      'da vinci',
      'ornithopter',
      'flying machine',
      'renaissance',
      'mona lisa',
      'vitruvian man',
    ],
  },
  {
    slug: 'tesla-colorado-springs',
    series: 'great-minds',
    number: 2,
    name: 'Colorado Springs Lab',
    maker: 'Nikola Tesla',
    year: 1899,
    tagline: 'Man-made lightning, under a barn roof.',
    story:
      'In a wooden lab on the Colorado plains, Tesla built a magnifying transmitter that threw sparks tens of feet across the room. The coil towers in the middle of the barn inside its copper-wound fence, the mast climbs past the walls to the copper ball, and bolts leap off every edge.',
    age: '18+',
    palette: {
      cover: '#2B3440',
      flood: '#3E5366',
      ink: '#EAF6F8',
      ground: '#D6E4EA',
      accent: '#AEE9EF',
    },
    aliases: [
      'tesla',
      'nikola tesla',
      'tesla coil',
      'lightning',
      'colorado springs',
      'electricity',
    ],
  },
  {
    slug: 'napoleon-alps',
    series: 'great-minds',
    number: 3,
    name: 'Crossing the Alps',
    maker: 'Napoleon Bonaparte',
    year: 1800,
    tagline: 'A rearing horse on the Great St Bernard.',
    story:
      'David painted the First Consul calm on a wild-eyed horse at the top of the pass, cloak flying. The horse rears here in profile on a rock ledge, hooves on two studs, while his grenadiers haul a cannon up the trail below the snow peaks.',
    age: '18+',
    palette: {
      cover: '#C9CFD4',
      flood: '#5C6770',
      ink: '#15202B',
      ground: '#E4E8EB',
      accent: '#B40000',
    },
    aliases: [
      'napoleon',
      'bonaparte',
      'alps',
      'david',
      'horse',
      'great st bernard',
    ],
  },
  {
    slug: 'caesar-rubicon',
    series: 'great-minds',
    number: 4,
    name: 'Crossing the Rubicon',
    maker: 'Julius Caesar',
    year: -49,
    tagline: 'The die is cast.',
    story:
      'In January of 49 BC, a general was forbidden to bring his army across this small river into Italy, and Caesar crossed it anyway, starting a civil war. The Thirteenth Legion wades the ford in column under his eye on horseback, the camp pitched behind them, a milestone marking the road beyond, and the gold eagle planted on his rise.',
    age: '18+',
    palette: {
      cover: '#7A2A22',
      flood: '#9C3A2E',
      ink: '#FBEFD9',
      ground: '#E6E9D8',
      accent: '#C9A227',
    },
    aliases: [
      'caesar',
      'julius caesar',
      'rubicon',
      'rome',
      'roman',
      'legion',
      'aquila',
    ],
  },
  {
    slug: 'wright-flyer',
    series: 'great-minds',
    number: 5,
    name: 'Wright Flyer',
    maker: 'Orville and Wilbur Wright',
    year: 1903,
    tagline: 'Twelve seconds that started aviation.',
    story:
      'At 10:35 on a cold morning at Kill Devil Hills, Orville lay on the lower wing and flew 120 feet in twelve seconds while Wilbur ran alongside the wingtip. The Flyer is caught just off its launching rail at full minifig scale, turned three-quarter to the viewer: white muslin wings on spruce struts, the biplane elevator out front, twin pusher propellers and rudders behind, the Wrights’ hangar and living shed on the sand beyond and John Daniels at the camera.',
    age: '18+',
    palette: {
      cover: '#E9DDC3',
      flood: '#C8B48A',
      ink: '#2B2416',
      ground: '#F2EBDB',
      accent: '#897D62',
    },
    aliases: [
      'wright brothers',
      'wright flyer',
      'kitty hawk',
      'first flight',
      'orville',
      'wilbur',
      'airplane',
    ],
  },
  {
    slug: 'einstein-desk',
    series: 'great-minds',
    number: 6,
    name: "Einstein's Study",
    maker: 'Albert Einstein',
    year: 1935,
    tagline: 'E = mc², in chalk and tiles.',
    story:
      'At 112 Mercer Street in Princeton, Einstein worked in an upstairs study heaped with papers and books. The equation is written in white tiles on a studs-sideways blackboard, beside portraits of Newton, Faraday and Maxwell, with his violin by the armchair.',
    age: '18+',
    palette: {
      cover: '#2F3A33',
      flood: '#4A5A4F',
      ink: '#F4F1E8',
      ground: '#E7E3D6',
      accent: '#D7BA8C',
    },
    aliases: [
      'einstein',
      'albert einstein',
      'relativity',
      'e=mc2',
      'princeton',
      'physics',
    ],
  },
]
